import { makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react-lite';
import { TFilter } from './types';
import { Input } from '@apia/theme';
import { useResponsiveTableContext } from '@apia/table';
import { TApiaFilter } from '@apia/util';

export type FilterState = TFilter;

export class Filter {
  filterState: FilterState = {
    runAutomatically: false,
    value: '',
  } as FilterState;

  constructor(properties: TFilter) {
    Object.assign(this.filterState, properties);

    makeObservable(this, { filterState: observable });
  }

  Component = observer(({ filter }: { filter: TApiaFilter }) => {
    const { onFilterBlur, onFilterChange, onFilterPressEnter } =
      useResponsiveTableContext();

    return (
      <Input
        value={this.filterState.value}
        onChange={(ev) => {
          this.filterState.value = ev.target.value;
          onFilterChange?.(filter);
        }}
        onKeyDown={(ev) => {
          if (ev.code === 'Enter') {
            onFilterPressEnter?.(filter);
          }
        }}
        onBlur={() => {
          onFilterBlur?.(filter);
        }}
      />
    );
  });
}
